import { atom } from 'jotai';

export const hashtagAtom = atom([]);
export const contributorAtom = atom([]);
